<!-- 点评弹框 -->
<template>
  <el-dialog :append-to-body="true" :visible.sync="centerDialogVisible" width="35%" center>
    <p class="p1">{{ initDatas.resourceName }}</p>
    <div style="display: flex;align-items: center;justify-content: space-between;">
       <p class="p2">我要评价</p>
       <el-button size="mini" @click="setTemplate" type="primary">设置模版</el-button>
    </div>
    <div class="starLine">
      <p class="starLineP1"><span>*</span>总体评价</p>
      <el-rate :disabled="disabledFlag" @change="rateChange" v-model="initDatas.overall"></el-rate>
      <p class="starLineP2">点击星星给商户评分</p>
    </div>
    <div class="starLine" v-for="item in rateList" :key="item.title">
      <p class="starLineP1"><span>*</span>{{ item.title }}</p>
      <el-rate v-model="initDatas[item.key]"></el-rate>
      <p class="starLineP2">给{{ item.title }}打分</p>
    </div>
    <div class="evaluate">
      <p class="starLineP1"><span>*</span>评价</p>
      <div style="width: 100%;">
        <el-input change="input1" v-if="isShow" style="margin-bottom: 0.05rem;" size="mini"
                  v-model="initDatas.title" placeholder="写个标题吧..."></el-input>
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5 }"
                  placeholder="分享酒店交通、 设施、服务、餐饮等方面的体验。多写点细节对大家更有帮助哦。"
                  v-model="initDatas.content">
        </el-input>
      </div>
      <el-button :disabled="!btnIsShow" v-if="!isShow" @click="isShow = true" size="mini" icon="el-icon-plus"
                 class="btns"
                 round>标题
      </el-button>
    </div>
    <div class="starLine" v-if="initDatas.replyContent">
      <p class="starLineP1" style="color: red;">供应商回复:</p>
      <p>{{ initDatas.replyContent }}</p>
    </div>
    <div class="imgOrVideo">
      <p class="starLineP1">图片/视频</p>
      <div class="imgs">
        <ResourceUpload ossPath="resource" :showFlodNames="['评价图片']" ref="upload" ossRoute="remarkPicture" v-model="picList"
                        :fileLimit="99" :parentId="String(parentId)" flodName="评价图片" listType='picture-card'>
        </ResourceUpload>
        <p class="imgsP1">照片</p>
      </div>
      <div class="imgs">
        <upload-video ref="upload1" :apply="apply" :parentId="String(parentId)" flodName="评价视频"
                      ossRoute="remarkVideo" @change="getVideo">
        </upload-video>
        <p class="imgsP1">视频</p>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
            <el-button v-if="btnIsShow" size="mini" type="primary" @click="send">发表评价</el-button>
            <el-button size="mini" @click="centerDialogVisible = false">{{ btnIsShow ? '取 消' : '关 闭' }}</el-button>
        </span>
  </el-dialog>
</template>

<script>
import ResourceUpload from "@/components/Upload/ResourceUpload.vue";
import UploadVideo from "../../../../../components/UploadVideo.vue";
import Api from '@/components/Api/index'
import OrderApi from '@/components/Api/order'

export default {
  components: {
    ResourceUpload,
    UploadVideo
  },
  data() {
    return {
      videoList: [],
      isShow: false,
      btnIsShow: true,
      disabledFlag:false,
      parentId: 0,
      picList: [],
      centerDialogVisible: false,
      initDatas: {},//渲染的数据
      rateList: [],
      value1: null,
      textarea2: '',
      apply: true,
    }
  },
  computed: {},
  watch: {},
  methods: {
    init(data,type) {
      this.apply = true
      this.disabledFlag = type ? true : false
      if( this.disabledFlag) {
        this.rateChange(-1)
      }
      console.log(data, '看坎坎坷坷看看');
      let rateArr = {
        '0': [{
          title: '位置',
          key: 'position'
        },
          {
            title: '服务',
            key: 'service'
          },
          {
            title: '卫生',
            key: 'health'
          },
          {
            title: '设施',
            key: 'fac'
          }],
        '4': [
          {
            title: '口味',
            key: 'food'
          },
          {
            title: '环境',
            key: 'environment'
          },
          {
            title: '服务',
            key: 'service'
          },
        ]
      }
      if (rateArr[data.state]) {
        this.rateList = rateArr[data.state]
      }
      console.log(this.rateList, '看看全部数据88888');
      //回显
      if (data.id) {
        this.parentId = data.id
        this.initDatas = data
        this.isShow = data.title
        this.btnIsShow = false
        this.apply = false
        this.centerDialogVisible = true
      } else {
        this.isShow = false
        this.centerDialogVisible = true
        let obj = {
          state: data.state,//资源类型
          resourceId: data.resourceId,//资源id
          resourceName: data.resourceName ? data.resourceName : data.resourceNameEn,//资源名字
          orderChildrenId: data.orderChildrenId,//子订单号
          label: type === '默认好评' ? '-1' : null,
        }
        const map = {
          '0': () => this.initDatas = {
            title: null,//标题
            overall: type === '默认好评' ? 5 : null,//总体评价
            position: type === '默认好评' ? 5 : null,//位置评价
            service: type === '默认好评' ? 5 : null,//服务评价
            health: type === '默认好评' ? 5 : null,//卫生评价
            fac: type === '默认好评' ? 5 : null,//设施评价
            content: '',//评价内容
          },
          '4': () => this.initDatas = {
            title: null,//标题
            overall: type === '默认好评' ? 5 : null,//总体评价
            food: type === '默认好评' ? 5 : null,//口味评价
            service: type === '默认好评' ? 5 : null,//服务评价
            environment: type === '默认好评' ? 5 : null,//用餐环境
            state: null,//资源类型
            resourceld: null,//资源id
            resourceName: null,//资源名字
            content: '',//评价内容
          }
        }
        if (map[data.state]) {
          map[data.state]()
          this.initDatas = {...this.initDatas, ...obj}
        } else {
          let obj1 = {
            title: null,//标题
            overall: type === '默认好评' ? 5 : null,//总体评价
            content: '',//评价内容
            label: type === '默认好评' ? '-1' : null,
          }
          this.initDatas = {...obj1, ...obj}
        }
      }
    },
    //前往模版设置页面
    setTemplate() {
      let obj = {
            currentComponent:'evaluateManager',
            buttom:'3'
      }
      this.$Bus.$emit('pagesSW',obj);
    },
    //模版选择
    rateChange(val) {
        console.log(val,'说的是弟弟');
        new OrderApi("order")
        .examineeEvaluationTemplate(val)
        .then((res) => {
          if (res.status == 200) {
            console.log(this.initDatas,res.data,'坎坎坷坷看看9999');
            if(res.data) {
              this.$message.success('成功使用默认模版')
              this.initDatas.content = res.data.content
              this.initDatas.label = res.data.label
            }else {
              this.$message.warning('暂无模版')
              this.initDatas.content = ''
              this.initDatas.label = this.initDatas.overall
            }
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    //发表评价
    send() {
      console.log('看看保存数据', this.initDatas);
      new Api("resource")
          .evaluate(this.initDatas)
          .then((res) => {
            if (res.status == 200) {
              this.$message.success({message: "发送成功"});
              this.$refs.upload.manualUpload(this.picList, res.data)
              this.$refs.upload1.videoUpload(this.videoList, res.data)
              this.centerDialogVisible = false
            } else {
              this.$message.error({message: res.statusText});
            }
          });
    },
    getVideo(event) {
      this.videoList = event
    },
  },
  created() {

  },
  mounted() {

  },
}
</script>
<style lang='scss' scoped>
/deep/ .el-input__inner {
  border-left: none !important;
  border-top: none !important;
  border-right: none !important;
  border-radius: 0 !important;
}

.p1 {
  font-size: 0.24rem;
  font-weight: bold;
  color: #4F5050;
  margin-bottom: 0.1rem;
}

.p2 {
  font-size: 0.22rem;
  color: #4F5050;
  margin-bottom: 0.1rem;
  width: 1rem;
  text-align: right;
}

.starLineP1 {
  margin-right: 0.15rem;
  min-width: 1rem;
  max-width: 1rem;
  text-align: right;

  span {
    color: red;
  }

  color: #4F5050;
}

.starLine {
  margin-bottom: 0.1rem;
  display: flex;
  align-items: center;


  .starLineP2 {
    margin-left: 0.1rem;
    color: #C7C7C7;
  }
}

.evaluate {
  display: flex;
  margin-bottom: 0.1rem;
  position: relative;

  .btns {
    position: absolute;
    bottom: 0.1rem;
    left: 1.4rem;
  }
}

.imgOrVideo {
  display: flex;

  .imgs {
    width: 1.48rem;
    height: 1.8rem;
    position: relative;
    overflow: hidden;
    margin-right: 0.1rem;

    .imgsP1 {
      text-align: center;
      margin-top: 0.05rem;
    }
  }
}
</style>